// extracted by mini-css-extract-plugin
module.exports = {"container":"RiskBandsList_container__bkeXz"};